<template>
  <span class="scratchcard-title font-medium text-uppercase" :class="size">
    {{ title }}
  </span>
</template>

<script lang="ts" setup>
type ScratchcardTitleProps = {
  color?: string
  size?: ScratchcardTitleSize
  title: string
}

type ScratchcardTitleSize = 'large' | 'medium' | 'small'

const { size = 'medium' } = defineProps<ScratchcardTitleProps>()
</script>

<style lang="scss" scoped>
.scratchcard-title {
  display: block;
  color: v-bind(color);

  &.large {
    @include token-headline-h3-headline;
  }

  &.medium {
    @include token-headline-h4-headline;
  }

  &.small {
    @include token-paragraph-bold;
  }
}
</style>
